import React from "react";
import style from "./brands.module.css";
import { IbrandsItem } from "../../../types/brands";
interface brnadProp {
  className?: string;
  title: string;
  isLink?: boolean;
  brands: IbrandsItem[];
  trackerName?: string;
}
const BrandItems: React.FC<brnadProp> = ({
  className,
  title,
  isLink,
  brands,
  trackerName,
}) => {
  return (
    <div className={`${style.brands} ${className ? className : ""}`}>
      {!!brands && (
        <div className={style["brands-inner"]}>
          <div className={style["brands-title"]}>
            {/* <img
              src={`${process.env.PUBLIC_URL}/assets/icon/start-palnet-icon.svg`}
              alt=""
            /> */}
            <span>{title}</span>
          </div>

          <div className={style["brands-items"]}>
            {brands.map((brand, index) =>
              !isLink ? (
                <div className={style["brands-item"]} key={index}>
                  <img src={`${brand.image}`} alt="brand" />
                </div>
              ) : (
                <a
                  id={`${index === 0 ? `${trackerName}-top-right` : ""}${
                    index === 1 ? `${trackerName}-top-left` : ""
                  }${index === 2 ? `${trackerName}-bottom-right` : ""}${
                    index === 3 ? `${trackerName}-bottom-left` : ""
                  }`}
                  href={brand.link}
                  target="_blank"
                  className={style["brands-item"]}
                  key={index}
                  rel="noreferrer"
                >
                  <img src={`${brand.image}`} alt="brand" />
                </a>
              )
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default BrandItems;
